import { FC } from "react";

interface SearchProps {
  size?: number;
}

const Search: FC<SearchProps> = ({ size = 24 }) => {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1866 14.4713H15.9766L20.2166 18.7313C20.6266 19.1413 20.6266 19.8113 20.2166 20.2213C19.8066 20.6313 19.1366 20.6313 18.7266 20.2213L14.4766 15.9713V15.1813L14.2066 14.9013C12.8066 16.1013 10.8966 16.7213 8.86658 16.3813C6.08658 15.9113 3.86658 13.5913 3.52658 10.7913C3.00658 6.56133 6.56658 3.00133 10.7966 3.52133C13.5966 3.86133 15.9166 6.08133 16.3866 8.86133C16.7266 10.8913 16.1066 12.8013 14.9066 14.2013L15.1866 14.4713ZM5.47658 9.97133C5.47658 12.4613 7.48658 14.4713 9.97658 14.4713C12.4666 14.4713 14.4766 12.4613 14.4766 9.97133C14.4766 7.48133 12.4666 5.47133 9.97658 5.47133C7.48658 5.47133 5.47658 7.48133 5.47658 9.97133Z"
          fill="black"
        />
      </svg>
    </>
  );
};

export default Search;
